var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A2550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.75 5.667c1.25-.834 2.917-.417 2.917 1.25 0 1.333-1.111 1.666-1.667 1.666v.834m0 2.5c.333 0 .417.277.417.416M9 11.917c-.333 0-.417.277-.417.416M9 11.917v.833m.417-.417c0 .14-.084.417-.417.417m.417-.417h-.834M9 12.75c-.333 0-.417-.278-.417-.417M16.5 9a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0"
  })));
};
export default SvgQuestion;